import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import LeftView from "@/features/auth/components/LeftView";
import NoDataFound from "@/components/NoDataFound";
import useQuery from "@/helpers/hooks/useQuery";
import { isLoggedInSelector } from "@/features/auth/store/authSlice";
import { authService } from "@/features/auth/services/authService";
import InvalidLinkMessage from "./InvalidLinkMessage";
import { logger } from "@/helpers/loggerHelper";
import { HTTP_STATUS } from "@/config/constants";
import { getDashboardPath } from "@/helpers/utils";

export default function ValidateEmailSignupLink() {
  const { token, subscribe } = useQuery();

  const isLoggedIn = useSelector(isLoggedInSelector);

  const [data, setDate] = useState<any>(null);
  const [isValidLink, setIsValidLink] = useState(false);
  const [hasCredential, setHasCredential] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    async function validateEmailLink() {
      setIsLoading(true);
      try {
        const res = await authService.validateLinkToken(String(token));

        if (res.status === HTTP_STATUS.OK) {
          const data = res.data;
          if (data) {
            setDate(data);
            setIsValidLink(data.isValidLink);
            setHasCredential(data.hasCredential);
          }
        }
      } catch (err) {
        logger.error("Error in validateLinkToken", { err });
      } finally {
        setIsLoading(false);
      }
    }
    if (token) {
      validateEmailLink();
    }
  }, [token]);

  const renderScreen = () => {
    if (isValidLink) {
      if (hasCredential) {
        return (
          <Navigate
            to={`/login?email=${data?.email}${
              subscribe ? "&subscribe=true" : ""
            }`}
            replace
          />
        );
      } else {
        return (
          <Navigate
            to={`/create-password`}
            state={{
              userData: data,
              token,
              subscribe,
            }}
            replace
          />
        );
      }
    } else {
      return <InvalidLinkMessage email={data?.email} subscribe={subscribe} />;
    }
  };

  if (isLoggedIn) {
    return <Navigate to={getDashboardPath()} replace />;
  }

  return (
    <div className="row login-page">
      <div className="col-lg-6 p-0 d-none d-lg-block">
        <LeftView />
      </div>
      <div className="col-lg-6 d-flex flex-column justify-content-center px-lg-5 py-1 py-sm-5 validate-email-signup-link">
        {isLoading ? <NoDataFound message="Validating..." /> : renderScreen()}
      </div>
    </div>
  );
}
